import React from 'react';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from './mixins/shared/string_constants_mixin';
import { generateNewLanguageUrl } from '../../../utils/localization';

const createReactClass = require('create-react-class');

const LanguageMenuDropdown = createReactClass({
  componentDidMount() {
    const current_lang = this.currentLocation();
    if (this.props.user_lang && current_lang && current_lang != this.props.user_lang) {
      this.redirectToProperLanguage(this.props.user_lang);
    }
    this.setState({ language: current_lang });
    return current_lang;
  },
  getInitialState() {
    return {
      selected_language: this.currentLocation()
    };
  },
  currentLocation() {
    let language = '/en';
    if (this.props && this.props.language_region_code) {
      const path_language_regex = this.props.language_region_code.substring(0, 2).match(/(es|fr|de)/);
      if (Array.isArray(path_language_regex)) {
        language = `/${path_language_regex[0]}`;
      }
    }
    return language;
  },
  change(event) {
    const new_lang_object = StringConstantsMixin.constants.SUPPORTED_LANGUAGES.filter(function(item) {
      return item.iso_3166_code.toLowerCase() === event.target.value.substring(1, 3);
    })[0];
    const new_lang = new_lang_object.iso_3166_code.toLowerCase();

    if (this.props.userSignedIn) {
      const { updateUser } = this;
      updateUser(new_lang).then(
        function() {
          this.redirectToProperLanguage(`/${new_lang}`);
        }.bind(this)
      );
    } else {
      this.redirectToProperLanguage(`/${new_lang}`);
      return true;
    }
  },
  redirectToProperLanguage(new_lang) {
    if (window) {
      window.location = generateNewLanguageUrl(window.location.pathname, new_lang);
    }
    this.setState({ selected_language: new_lang });
  },
  updateUser(new_lang) {
    // manually set payload since structs don't align
    const headers = new_lang ? { 'X-Language-Locale': new_lang } : {};
    return new Promise((resolve, reject) => {
      ServerCommunicationUtil.putApiEndpoint(
        '/api/alltrails/me/',
        {
          marketingLangPreference: new_lang
        },
        resolve,
        reject,
        () => {},
        headers
      );
    });
  },
  render() {
    const select_language_options = [];
    for (let i = 0; i < StringConstantsMixin.constants.SUPPORTED_LANGUAGES.length; i++) {
      select_language_options.push(
        <option
          className={StringConstantsMixin.constants.XLATE.NONE}
          key={i}
          value={`/${StringConstantsMixin.constants.SUPPORTED_LANGUAGES[i].iso_3166_code.toLowerCase()}`}
        >
          {StringConstantsMixin.constants.SUPPORTED_LANGUAGES[i].language_drop_down_name}
        </option>
      );
    }
    return (
      <div className="input optional select">
        <span className="dropdown language-selector dropdown-arrow">
          <select
            aria-label={StringConstantsMixin.strings.SELECT_LANGUAGE}
            onChange={this.change}
            className={StringConstantsMixin.constants.XLATE.NONE}
            value={this.state.selected_language}
          >
            {select_language_options}
          </select>
        </span>
      </div>
    );
  }
});

export { LanguageMenuDropdown };
